import { Validator } from '../../../common/hooks/useFormControls';

const validVideoUrl = Validator(
  (value) => {
    // not blank
    let valid = true;
    if (!value) valid = false;
    // YouTube or Vimeo URLs
    const regex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|vimeo\.com\/)([a-zA-Z0-9_-]+)(\?.*)?$/;
    return regex.test(value) && valid;
  },
  { code: 'invalid-url', message: 'Invalid URL' },
);

export const uniqueNameValidator = (file, addOns) => {
  let result = null;
  const safeAddOns = addOns || [];
  if (safeAddOns.some((addOn) => addOn.file_name === file.name)) {
    result = { error: 'duplicate-file', fileName: file.name };
  }
  return result;
};

export default [
  { fieldName: 'embedUrl', value: '', validators: [validVideoUrl] },
];
